import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { message } from 'antd';
import _ from 'lodash';
import { authUserError } from 'pages/AppLogin/action';
import { listMessage, addMessage, editMessage } from 'services/message';
import { ADD_MESSAGE, EDIT_MESSAGE, LIST_MESSAGE, TOGGLE_DRAWER, TOGGLE_DELETE_MODAL } from './constant';
import { listMessage as listMessageAction, listMessageSuccess, listMessageError, addMessageSuccess, addMessageError, editMessageSuccess, editMessageError, toggleDrawer, toggleDeleteModal } from './action';

export function* listMessageSaga(action) {
  try {
    const res = yield call(listMessage, action.payload);
    const messageData = JSON.parse(res.text);
    // console.log(messageData)

    yield put(
      listMessageSuccess({
        attributes: messageData.data.messages.map((item) => ({
          ...item,
          key: item.message_id,
        })),
      }),
    );
  } catch (err) {
    if (_.isEqual(err.status, 401)) {
      yield put(listMessageError(err.response.text));
      yield put(authUserError({}));
    }
    if (_.isEqual(err.status, 422)) {
      const serverError = JSON.parse(err.response.text);
      message.error(serverError[0].message);
      yield put(listMessageError(err.response.text));
    }
    if (_.isEqual(err.status, 500)) {
      message.error('Something went wrong');
    }
  }
}
export function* addMessageSaga(action) {
  try {
    const res = yield call(addMessage, action.payload);
    const userData = JSON.parse(res.text);
    yield put(addMessageSuccess(userData.data));
    yield put(toggleDrawer());
    yield put(listMessageAction({ page: 1, limit: 10 }));
    message.success(userData.data.message);
  } catch (err) {
    if (_.isEqual(err.status, 401)) {
      yield put(addMessageError(err.response.text));
      yield put(authUserError({}));
    }
    if (_.isEqual(err.status, 400)) {
      const serverError = JSON.parse(err.response.text);
      message.error(serverError.message);
      yield put(addMessageError());
    }
    if (_.isEqual(err.status, 422)) {
      const serverError = JSON.parse(err.response.text);
      message.error(serverError[0].message);
      yield put(addMessageError(err.response.text));
    }
    if (_.isEqual(err.status, 500)) {
      message.error('Something went wrong');
    }
  }
}

export function* editMessageSaga(action) {
  try {
    const res = yield call(editMessage, action.payload);
    const userData = JSON.parse(res.text);
    yield put(editMessageSuccess(userData.data));
    yield put(toggleDrawer());
    yield put(listMessageAction({ page: 1, limit: 10 }));
    message.success(userData.data.message);
  } catch (err) {
    if (_.isEqual(err.status, 401)) {
      yield put(editMessageError());
      yield put(authUserError({}));
    }
    if (_.isEqual(err.status, 422)) {
      const serverError = JSON.parse(err.response.text);
      message.error(serverError[0].message);
      yield put(editMessageError());
    }
    if (_.isEqual(err.status, 409)) {
      const serverError = JSON.parse(err.response.text);
      message.error(serverError.message);
      yield put(editMessageError());
    }
    if (_.isEqual(err.status, 500)) {
      message.error('Something went wrong');
    }
  }
}

export function* toggleDrawerSaga(action) {
  put(toggleDrawer());
}

export function* toggleDeleteModalSaga(action) {
  put(toggleDeleteModal());
}

export default function* MessageSaga() {
  yield takeLatest(LIST_MESSAGE, listMessageSaga);
  yield takeEvery(ADD_MESSAGE, addMessageSaga);
  yield takeEvery(EDIT_MESSAGE, editMessageSaga);
  yield takeEvery(TOGGLE_DRAWER, toggleDrawerSaga);
  yield takeEvery(TOGGLE_DELETE_MODAL, toggleDeleteModalSaga);
}
